<template lang="pug">
  .product-title
    component.name(
      :is="headerTag"
      :class="{'sr-only': imageConfig, 'h1-style': !showH1}"
    ) 
      | {{ product.name }}
    DynamicMedia.title-img(v-if="imageConfig" :config="imageConfig" :style="`max-width: ${maxImageWidth > 0 ? maxImageWidth + 'px' : '100%'}`")
    .main-line
      .t-shirt-fit-badge(v-if="product.attributes.t_shirt_fit") {{ __(`${product.attributes.t_shirt_fit} Fit`) }}
      product-stars(:product="product" :condensed="false")
      Badge(
        v-if="product.attributes.made_in_usa !== undefined && (product.attributes.made_in_usa !== 'No' || product.attributes.rogue_assembled_usa)"
        icon="flag-usa"
        :secondary-icon="secondaryIcon"
      )
        Icon.secondary-icon( v-if="secondaryIcon" :name="secondaryIcon" )
        .badge-text(:class="{'small-badge-text': custom}" v-if="product.attributes.made_in_usa && custom === 'Frame'")
          | {{__('US Made Frame & Assembled in US')}}
        .badge-text(:class="{'small-badge-text': custom}" v-else-if="product.attributes.made_in_usa")
          | {{__('Made in U.S.A.')}} {{custom}}
        .badge-text(v-else-if="product.attributes.rogue_assembled_usa")
          | {{__('Assembled in U.S.A.')}}
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import ProductStars from '@/js/components/product-stars.vue'
import Badge        from '@/js/components/rhpa/badge.vue'
import type { Product } from '@/js/services/RogueTypes'

const props = defineProps<{
  product: Product,
  showH1?: boolean | undefined, 
}>()

const maxImageWidth = computed(() => props.product.roguebuilder?.props?.productTitleImage?.maxWidth)
const imageConfig = computed(() => {
  const image = props.product.roguebuilder?.props?.productTitleImage
  if (!image || !image.src) return undefined

  const alt = props.product.name
  const autoHeight = true
  const background: string = image.background

  const config = {
    src    : image.src,
    height : image.height,
    width  : image.width,
    alt,
    autoHeight,
    background,
    mobile : image.mobile ? {
      src    : image.mobile.src,
      height : image.mobile.height,
      width  : image.mobile.width,
      alt,
      autoHeight,
      background,
    } : undefined,
  }

  return config
})

const custom = computed(() => (props.product.attributes.made_in_usa_custom)?.toString().split('_')[0] || '')

const secondaryIcon = computed(() => {
  if (
    custom.value.toLowerCase().indexOf('eu steel') !== -1
    || custom.value.toLowerCase().indexOf('german bearings') !== -1
  ) {
    return 'flag-eur-blue'
  }
  if (custom.value.toLowerCase().indexOf('can steel') !== -1) {
    return 'flag-can'
  }

  return null
})

const headerTag = computed<string>(() => {
  return props.showH1 ? 'h1' : 'h2'
})

</script>
<style lang="scss" scoped>

.main-line {
  margin-bottom: $space-xxs;
}

.small-badge-text {
  font-size: 9px;
}

.t-shirt-fit-badge {
  font-size: $size-xxs;
  margin-bottom: $space-xxs;
}

// The EU and CA logos are squares, so they looked bigger than US
.secondary-icon {
  width: $space-s;
  height: $space-s;
  margin-right: $space-xxxs;
}

.title-img {
  margin-bottom: $space-xxxs;
}

.sr-only {
  position:absolute;
  left:-10000px;
  top:auto;
  width:1px;
  height:1px;
  overflow:hidden;
}

.h1-style{
  font-size: $size-xxl;
}

</style>
